import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';

function DownloadsContainer() {
  const {
    allContentfulDownload: { nodes: downloads },
  } = useStaticQuery(graphql`
    query GetDownloads {
      allContentfulDownload(sort: { fields: updatedAt, order: DESC }) {
        nodes {
          id
          title
          updatedAt(formatString: "MMMM DD, YYYY")
          description
          downloadLink
        }
      }
    }
  `);

  return (
    <div className='container' style={{ paddingTop: '8rem' }}>
      <h2 className='text-center download-title'>Downloads</h2>
      {downloads.length < 1 ? (
        <h5 className='text-center text-danger mt-5'>No downloadable data found!</h5>
      ) : (
        <div className='row'>
          {downloads.map((download) => (
            <div key={download.id} className='col-md-6 w-100 mx-auto'>
              <div className='download-card'>
                <div className='info'>
                  <p className='date'>{download.updatedAt}</p>
                  <h4>{download.title}</h4>
                  <p className='desc'>{download.description}</p>
                </div>
                <a className='btn btn-success' href={download.downloadLink} target='_blank' rel='noopener noreferrer'>
                  Download
                </a>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default DownloadsContainer;
